var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classContainer},[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar,"alt":""}}):_c('img',{attrs:{"src":require("@/assets/images/avatar.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }